var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.setClass(_vm.config) },
    [
      _c(
        _vm.config.name,
        _vm._b(
          {
            ref: "form",
            tag: "component",
            attrs: {
              mode: _vm.mode,
              readerMode: _vm.readerMode,
              perm: _vm.config.perm,
              labelTitle: _vm.config.title,
              userInfo: _vm.userInfo,
            },
            on: { change: _vm.change, delInput: _vm.delInput },
            model: {
              value: _vm._value,
              callback: function ($$v) {
                _vm._value = $$v
              },
              expression: "_value",
            },
          },
          "component",
          _vm.config.props,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }